import Banner from '@carvana/ds-banner';
import { useEffect, useState } from 'react';
import { BrowserCookies } from '~/utilities';
import { staleFeatureBranchCookieName } from '~/utilities/featureBranch';

export default function StaleFeatureBranchAlert() {
  const [showAlert, setShowAlert] = useState(false);

  // Read once on mount — the cookie is short lived, so holding the result in
  // state keeps the alert up long enough to be acknowledged.
  useEffect(() => {
    setShowAlert(BrowserCookies.get(staleFeatureBranchCookieName) === '1');
  }, []);

  const handleAccept = () => {
    BrowserCookies.remove(staleFeatureBranchCookieName);
    setShowAlert(false);
  };

  return (
    <Banner
      className="pointer-events-auto m-md w-fit max-w-full"
      data-testid="stale-feature-branch-alert"
      icon
      open={showAlert}
      type="warning"
    >
      <Banner.Headline>Feature branch no longer available</Banner.Headline>
      <Banner.Message>
        The feature branch you were viewing has been torn down, so you are back
        on the standard test environment.
      </Banner.Message>
      <Banner.Button
        onClick={handleAccept}
        data-analytics-id="Feature Branch - Dismiss stale branch alert"
        data-testid="dismiss-stale-feature-branch-alert"
      >
        Got it
      </Banner.Button>
    </Banner>
  );
}
